import PresentIcon from '@material-ui/icons/CardGiftcard';
import { APP_TYPES, roles } from '../../../config/constants';
import ScheduleList from '../ScheduleList';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.BA, roles.JTI_TEAM, roles.RSM, roles.USER],
  label: 'Present',
  subMenuName: 'scheduleList',
};

export default {
  list: ScheduleList,
  icon: PresentIcon,
  name: 'admin/schedule/type/present',
  options,
};
